<template>
  <GrupoLeyendaCheck
    titulo="Vegetación"
    v-model="vegetacion_expanded"
    checkboxType="switch"
  >
    <!-- <BotonQuitarTodos @click="quitarTodos" v-width-control="'30%'" /> -->
    <span v-width-control="'40%'"></span>
    <BotonMasInfo @click="masInfo" v-width-control="'45%'" />
    <DaiLeyendaMapa
      :para="[
        'vegetacion_bosque_encino',
        'vegetacion_bosque_encino_arborea',
        'vegetacion_bosque_encino_arbustiva',
        'vegetacion_bosque_encino_herbacea',
      ]"
      titulo="Bosque de encino"
      v-width-control="'100%'"
      :mostrar-boton-alterna-todos="true"
      estilo-boton-alterna-todos="checkbox"
      :colapsable="true"
    />
    <hr class="dai-map-separator thin" />
    <DaiLeyendaMapa
      :para="[
        'vegetacion_bosque_encino_pino',
        'vegetacion_bosque_encino_pino_arbustiva',
      ]"
      titulo="Bosque de encino-pino"
      v-width-control="'100%'"
      :mostrar-boton-alterna-todos="true"
      estilo-boton-alterna-todos="checkbox"
      :colapsable="true"
    />
    <hr class="dai-map-separator thin" />
    <DaiLeyendaMapa
      :para="[
        'vegetacion_bosque_oyamel',
        'vegetacion_bosque_oyamel_arbustiva',
      ]"
      titulo="Bosque de oyamel"
      v-width-control="'100%'"
      :mostrar-boton-alterna-todos="true"
      estilo-boton-alterna-todos="checkbox"
      :colapsable="true"
    />
    <hr class="dai-map-separator thin" />
    <DaiLeyendaMapa
      :para="[
        'vegetacion_bosque_pino',
        'vegetacion_bosque_pino_arborea',
        'vegetacion_bosque_pino_arbustiva',
      ]"
      titulo="Bosque de pino"
      v-width-control="'100%'"
      :mostrar-boton-alterna-todos="true"
      estilo-boton-alterna-todos="checkbox"
      :colapsable="true"
    />
    <hr class="dai-map-separator thin" />
    <DaiLeyendaMapa
      :para="[
        'vegetacion_bosque_pino_encino',
        'vegetacion_bosque_pino_encino_arborea',
        'vegetacion_bosque_pino_encino_arbustiva',
      ]"
      titulo="Bosque de pino-encino"
      v-width-control="'100%'"
      :mostrar-boton-alterna-todos="true"
      estilo-boton-alterna-todos="checkbox"
      :colapsable="true"
    />
    <hr class="dai-map-separator thin" />
    <DaiLeyendaMapa
      :para="[
        'vegetacion_bosque_tascate',
        'vegetacion_bosque_tascate_arborea',
        'vegetacion_bosque_tascate_arbustiva',
      ]"
      titulo="Bosque de táscate"
      v-width-control="'100%'"
      :mostrar-boton-alterna-todos="true"
      estilo-boton-alterna-todos="checkbox"
      :colapsable="true"
    />
    <hr class="dai-map-separator thin" />
    <DaiLeyendaMapa
      :para="[
        'vegetacion_matorral_crasicaule',
        'vegetacion_matorral_crasicaule_arbustiva',
        'vegetacion_matorral_desertico_rosetofilo',
      ]"
      titulo="Matorrales"
      v-width-control="'100%'"
      :mostrar-boton-alterna-todos="true"
      estilo-boton-alterna-todos="checkbox"
      :colapsable="true"
    />
    <hr class="dai-map-separator thin" />
    <DaiLeyendaMapa
      :para="[
        'vegetacion_pastizal_cultivado',
        'vegetacion_pastizal_inducido',
        'vegetacion_pastizal_halofilo',
      ]"
      titulo="Pastizales"
      v-width-control="'100%'"
      :mostrar-boton-alterna-todos="true"
      estilo-boton-alterna-todos="checkbox"
      :colapsable="true"
    />
    <hr class="dai-map-separator thin" />
    <DaiLeyendaMapa
      :para="[
        'vegetacion_bosque_cultivado',
        'vegetacion_halofila_hidrofila',
        'vegetacion_pradera_alta_montana',
        'vegetacion_tular',
        'vegetacion_sin_vegetacion_aparente',
        'vegetacion_desprovisto_vegetacion',
      ]"
      titulo="Otra"
      v-width-control="'100%'"
      :mostrar-boton-alterna-todos="true"
      estilo-boton-alterna-todos="checkbox"
      :colapsable="true"
    />
  </GrupoLeyendaCheck>
</template>

<script>
import GrupoLeyendaCheck from "./utils/GrupoLeyendaCheck.vue";
import BotonMasInfo from "./utils/BotonMasInfo.vue";
// import BotonQuitarTodos from "./utils/BotonQuitarTodos.vue";
import { scrollTo } from "@/components/_utils.js";

export default {
  computed: {
    vegetacion_expanded: {
      get() {
        return this.$store.state.mapa.temasExpandidos.vegetacion;
      },
      set(expandido) {
        this.$store.commit("mapa/setTemasExpandidos", {
          tema: "vegetacion",
          expandido: expandido,
        });
      },
    },
  },
  methods: {
    quitarTodos() {
      console.log("apagar todas las capas de vegetacion");
    },
    masInfo() {
      this.$store.commit("mapa/setFichaActiva", "vegetacion");
      scrollTo(document.querySelector("[data-section='fichas']"),-102);
    },
  },
  components: {
    GrupoLeyendaCheck,
    // BotonQuitarTodos,
    BotonMasInfo,
  },
};
</script>